export default "__VITE_ASSET__B7aM_ke8__"